<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16ayfZJ/tc-custom/9780300129878.jpg?1705319558109" alt="This image is the cover for the book Venona, Annals of Communism"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Venona, Annals of Communism
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This groundbreaking historical study reveals the shocking infiltration of Soviet spies in America—and the top-secret cryptography program that caught them.</b><br/><br/> Only in 1995 did the United States government officially reveal the existence of the super-secret Venona Project. For nearly fifty years American intelligence agents had been decoding thousands of Soviet messages, uncovering an enormous range of espionage activities carried out against the United States during World War II by its own allies. This extraordinary book is the first to examine the Venona messages—documents of unparalleled importance for our understanding of the history and politics of the Stalin era and the early Cold War years.<br/><br/> Hidden in a former girls’ school in the late 1940s, Venona Project cryptanalysts, linguists, and mathematicians attempted to decode thousands of intercepted Soviet intelligence telegrams. When they cracked the Soviet code, analysts uncovered information of powerful significance: the first indication of Julius Rosenberg’s espionage efforts; references to the espionage activities of Alger Hiss; proof of Soviet infiltration of the Manhattan Project; evidence that spies had reached the highest levels of the U.S. State and Treasury Departments; indications that more than three hundred Americans had assisted in the Soviet theft of American secrets; and confirmation that the Communist party of the United States was consciously and willingly involved in Soviet espionage against America.<br/><br/> Drawing not only on the Venona papers but also on newly opened Russian and U. S. archives, John Earl Haynes and Harvey Klehr provide the most rigorously documented analysis ever written on Soviet espionage in the early Cold War years. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Earl Haynes, Harvey Klehr
      </h2>
      
      <p class="authorDescription body article"><B>John Earl Haynes</B> is 20th Century Political Historian, Manuscript Division, the Library of Congress. Harvey Klehr is Andrew W. Mellon Professor of Politics and History at Emory University. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f7befdd